import _objectSpread from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/es.function.name.js";

// Copyright 2017-2022 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
function trimDocs(docs) {
  var strings = docs.map(function (d) {
    return d.toString().trim();
  });
  var firstEmpty = strings.findIndex(function (d) {
    return !d.length;
  });
  return firstEmpty === -1 ? strings : strings.slice(0, firstEmpty);
}
/** @internal */


export function toCallsOnly(registry, _ref) {
  var extrinsic = _ref.extrinsic,
      lookup = _ref.lookup,
      pallets = _ref.pallets;
  return registry.createTypeUnsafe('MetadataLatest', [{
    extrinsic: extrinsic,
    lookup: {
      types: lookup.types.map(function (_ref2) {
        var id = _ref2.id,
            type = _ref2.type;
        return registry.createTypeUnsafe('PortableType', [{
          id: id,
          type: _objectSpread(_objectSpread({}, type), {}, {
            docs: trimDocs(type.docs)
          })
        }]);
      })
    },
    pallets: pallets.map(function (_ref3) {
      var calls = _ref3.calls,
          index = _ref3.index,
          name = _ref3.name;
      return {
        calls: registry.createTypeUnsafe('Option<PalletCallMetadataLatest>', [calls.unwrapOr(null)]),
        index: index,
        name: name
      };
    })
  }]).toJSON();
}